// extracted by mini-css-extract-plugin
export var boxItems = "_co-1";
export var boxItemsLg = "_co-2";
export var button = "_co-7";
export var buttonLg = "_co-8";
export var filterGroupBox = "_co-0";
export var icon = "_co-3";
export var iconSecondary = "_co-6";
export var iconWrapper = "_co-4";
export var iconWrapperLg = "_co-5";